// extracted by mini-css-extract-plugin
export default {"filter":"style_filter__DFDCO"};